export const ENDPOINT = process.env.ENDPOINT
export const WS_ENDPOINT = process.env.WS_ENDPOINT



// WEBPACK FOOTER //
// ./src/api/index.js